import * as React from 'react'
import styled from 'styled-components/macro'
import Logo from 'assets/images/Logo1.svg'
import Modal from './Modal'
import LocalOnlyTag from 'common/LocalOnlyTag'
import {QUERIES} from 'common/constants'
import {submitQuoteRequest} from 'common/sendEmail'
import {
  Line,
  StyledInput,
  StyledLabel,
  StyledForm,
  Title,
  StyledTextArea,
  Button,
} from 'common/ModalFormComponents'

const SectionStyle = styled.div`
  background-color: ${({background}) =>
    background === 'dark'
      ? 'var(--darker-grey)'
      : background === 'none'
      ? 'initial'
      : 'var(--dark-grey)'};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 64px 16px;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  @media ${QUERIES.tabletAndUp} {
    flex-direction: ${({alignImg}) =>
      alignImg === 'left' ? 'row' : 'row-reverse'};
    padding: 160px 128px;
    gap: 80px;
  }

  img {
    max-height: 380px;
  }
  iFrame {
    max-width: 100% !important;
    height: 384px;
    width: 552px;
  }
  h2 {
    font-family: Rubik;
    color: white;
    font-style: italic;
    font-weight: 700;
    font-size: calc(24 / 16 * 1rem);
    line-height: 28px;
    text-align: center;
    @media ${QUERIES.tabletAndUp} {
      font-size: calc(40 / 16 * 1rem);
      line-height: 47px;
      text-align: initial;
    }
    text-transform: uppercase;
  }

  li {
    font-family: 'Mulish';
    font-weight: 300;
    font-size: calc(16 / 16 * 1rem);
    line-height: 20px;
    @media ${QUERIES.tabletAndUp} {
      font-size: calc(24 / 16 * 1rem);
      line-height: 30px;
    }
  }
  button {
    display: flex;
    justify-content: center;
    width: 211px;
    transition: all 1s ease;
    background-color: var(--light-green);
    color: var(--white);
    border-radius: 5px;
    font-family: 'Rubik';
    font-weight: 700;
    font-size: 16px;
    line-height: 14px;
    display: flex;
    align-items: center;
    text-align: center;
    text-transform: uppercase;
    white-space: nowrap;
    text-decoration: none;
    padding: 16px 32px;
    border-radius: 5px;
    border: none;
    cursor: pointer;
  }
`
const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  @media ${QUERIES.tabletAndUp} {
    align-items: flex-start;
  }
  gap: 24px;
`

const ModalContent = styled.div`
  color: var(--dark-grey);
  display: flex;
  background-color: white;
  /* height: 394px; */
  padding: 40px 16px;
  @media ${QUERIES.tabletAndUp} {
    padding: 40px 56px;
  }
  font-family: 'Mulish';
  font-size: calc(16 / 16 * 1rem);
  font-weight: 300;
  box-shadow: 10px 10px 10px rgba(26, 26, 26, 0.65);
  transition: right 1s ease-in-out;
  right: ${p => (p.open ? '0' : '-737px')};
  border-radius: 0 0 0 5px;
`
const SectionContent = styled.div`
  font-family: 'Mulish';
  text-align: center;
  line-height: 20px;
  @media ${QUERIES.tabletAndUp} {
    line-height: 30px;
    font-size: calc(24 / 16 * 1rem);
    max-width: 40vw;
    text-align: initial;
  }
  font-weight: 300;
`

const RequestButton = styled.button`
  display: ${p => (p.hideButtonMobile ? 'none' : 'flex')} !important;
  @media ${QUERIES.tabletAndUp} {
    display: flex !important;
  }
`

const NameLine = styled.div`
  display: flex;
  flex-direction: column;
  @media ${QUERIES.tabletAndUp} {
    flex-direction: row;
    gap: 16px;
  }
`

const ButtonRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
`

const ContentSection = ({
  img = Logo,
  youtubeLink = '',
  imgAlt = '',
  alignImg = 'left',
  heading,
  listItems,
  content,
  buttonText = 'Request A Quote',
  modalTitle = 'Request A Quote',
  background,
  hideButton = false,
  hideButtonMobile = false,
  type = 'quote',
  localOnly = false,
}) => {
  const [showModal, setShowModal] = React.useState(false)
  const toggleModal = () => setShowModal(!showModal)
  const [submitting, setSubmitting] = React.useState(false)
  const [submitSuccess, setSubmitSuccess] = React.useState(false)

  const closeModal = () => {
    setSubmitting(false)
    setSubmitSuccess(false)
    setShowModal(false)
  }

  return (
    <SectionStyle background={background} alignImg={alignImg}>
      {!youtubeLink && <img src={img} alt={imgAlt} />}
      {youtubeLink && (
        <iframe
          src={youtubeLink}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      )}
      <Column>
        {localOnly && <LocalOnlyTag />}
        <h2>{heading}</h2>
        {listItems && (
          <ul>
            {listItems.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        )}
        {content && <SectionContent>{content}</SectionContent>}
        {!hideButton && (
          <RequestButton
            hideButtonMobile={hideButtonMobile}
            onClick={toggleModal}
          >
            {buttonText}
          </RequestButton>
        )}
      </Column>
      {/* {alignImg === 'right' && <img src={img} alt={imgAlt} />} */}
      {showModal && (
        <Modal isOpen={showModal} onDismiss={() => closeModal()}>
          <ModalContent>
            <StyledForm
              name="request-quote"
              id="request-quote"
              method="POST"
              data-netlify={true}
            >
              <input name="subject" hidden value={type} readOnly />
              <Title>{modalTitle}</Title>
              <NameLine>
                <Line>
                  <StyledLabel name="Contact Name" htmlFor="First Name">
                    First Name
                  </StyledLabel>
                  <StyledInput width="228" name="First Name"></StyledInput>
                </Line>
                <Line>
                  <StyledLabel name="Contact Name" htmlFor="First Name">
                    Last Name
                  </StyledLabel>
                  <StyledInput width="228" name="Last Name"></StyledInput>
                </Line>
              </NameLine>
              <Line>
                <StyledLabel name="email" htmlFor="email">
                  Email
                </StyledLabel>
                <StyledInput
                  type="email"
                  width="553"
                  name="email"
                  required
                  id="email"
                ></StyledInput>
              </Line>
              <Line>
                <StyledLabel name="Phone" htmlFor="Phone">
                  Phone
                </StyledLabel>
                <StyledInput width="546" name="Phone"></StyledInput>
              </Line>
              <Line>
                <StyledLabel>Additional Information</StyledLabel>
                <StyledTextArea
                  width="425"
                  name="Additional Information"
                  rows={2}
                />
              </Line>
              <ButtonRow>
                {submitSuccess ? (
                  <div>Request Sent!</div>
                ) : (
                  <Button
                    type="button"
                    disabled={submitting}
                    onClick={() =>
                      submitQuoteRequest({
                        setSubmitSuccess,
                        setSubmitting,
                        formID: 'request-quote',
                      })
                    }
                    submitting={submitting}
                  >
                    {submitting ? 'Sending...' : 'Send'}
                  </Button>
                )}
              </ButtonRow>
              <input type="hidden" name="Type" value={type} readOnly />

              <input
                type="hidden"
                name="form-name"
                value="request-quote"
                readOnly
              />
            </StyledForm>
          </ModalContent>
        </Modal>
      )}
    </SectionStyle>
  )
}
export default ContentSection
